var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { runIfFn } from '../utils/index.js';
export const Radio = props => {
    const { active = false, checked = false, disabled, children, className } = props, rest = __rest(props, ["active", "checked", "disabled", "children", "className"]);
    return (React.createElement("div", { className: "relative flex focus:outline-none" },
        React.createElement("span", Object.assign({ className: clsx(checked
                ? 'bg-action-primary border-transparent'
                : 'bg-surface border-border', 'focus:outline-none focus-visible:ring', 'h-4 w-4 mt-0.5 rounded-full border flex items-center justify-center', !disabled && 'cursor-pointer ', disabled && 'opacity-60 cursor-default', className), "aria-hidden": "true" }, rest),
            React.createElement("span", { className: "rounded-full bg-surface w-1.5 h-1.5" })),
        React.createElement("div", { className: "ms-3 flex flex-1 flex-col" }, runIfFn(children, {
            checked,
            active,
            disabled,
        }))));
};
//# sourceMappingURL=Radio.js.map